<template>
  <div class="not-found">
    <Header />
    <div>
      <h2>ページが見つかりません</h2>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/modules/header';

export default {
  components: {
    Header,
  }
}
</script>
